import { useState, useEffect, useRef, useCallback } from "react";
import {
    Table, Thead, Tbody, Tr, Th, Td, Image, Button, Select,
    Flex, Box, Text, IconButton, Checkbox, HStack, Input,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton,
    useDisclosure, FormControl, FormLabel, Divider, Badge, Grid, GridItem,
    Switch,
    Tooltip
} from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import searchIcon from "../../assets/icons/search.svg";
import sortIcon from "../../assets/icons/sort.svg";
import eyeIcon from "../../assets/icons/eye.svg";
import copyIcon from "../../assets/icons/Copy.svg";
import filterIcon from "../../assets/icons/calendar.svg";
import { useNavigate } from "react-router-dom";
import useAxios from "../Context/axiosInstance";
import { useAuth } from "../Context/authContext";
import axios from "axios";
import { Config } from "../Utils/Config";
import Footer from "../footer";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { TbDownload } from "react-icons/tb";
import { faL } from "@fortawesome/free-solid-svg-icons";

const tableHeadings = [
    "Distributor /CNF Name", "User Since", "Valid Until", "Last Active",
    // "Type",
    "Phone", "Email", "Party Code", "Action", "Location", "Status", "Role Details", "Profile"
];

const FILTER_OPTIONS = [
    { label: "0 - 1 Months", value: "0-1" },
    { label: "1 - 3 Months", value: "1-3" },
    { label: "3 - 6 Months", value: "3-6" },
    { label: "6 - 9 Months", value: "6-9" },
    { label: "9 - 12 Months", value: "9-12" },
];

const thinScrollbarStyles = {
    scrollbarWidth: "thin", // Firefox
    scrollbarColor: "#A0A0A0 transparent",

    "&::-webkit-scrollbar": {
        width: "6px",  // Vertical scrollbar
        height: "6px", // Horizontal scrollbar
    },

    "&::-webkit-scrollbar-track": {
        background: "transparent",
    },

    "&::-webkit-scrollbar-thumb": {
        background: "#A0A0A0",
        borderRadius: "10px",
    },

    "&::-webkit-scrollbar-thumb:hover": {
        background: "#777777",
    },
};

const formatDateOnly = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);

    if (Number.isNaN(date.getTime())) return "N/A";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);

    return `${day}/${month}/${year}`;
};

const formatLastActive = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);

    if (Number.isNaN(date.getTime())) return "N/A";

    const datePart = formatDateOnly(dateString);

    const timePart = date.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    return `${datePart} - ${timePart}`;
};

const Distributorlist = () => {
    // State variables for pagination and filtering
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [status, setStatus] = useState("");
    const [search, setSearch] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isFilterActive, setIsFilterActive] = useState(false);
    const [tempStartDate, setTempStartDate] = useState("");
    const [tempEndDate, setTempEndDate] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(true);

    // State for data
    const [distributors, setDistributors] = useState([]);
    const [selectedDistributor, setSelectedDistributor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const containerRef = useRef(null);
    const currentPageRef = useRef(0);
    const isFetchingRef = useRef(false);
    const requestIdRef = useRef(0);

    // Modal controls
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
        isOpen: isDetailsOpen,
        onOpen: onDetailsOpen,
        onClose: onDetailsClose
    } = useDisclosure();

    const axiosInstances = useAxios();
    const { authToken } = useAuth();
    const nav = useNavigate();

    const [openAlertModal, setOpenAlertModal] = useState(false);
    const [selectedDistributorId, setSelectedDistributorId] = useState(null);
    const [timeFilter, setTimeFilter] = useState("1-3");

    const handleOpenAlertModal = (userId) => {
        setSelectedDistributorId(userId);

        setTimeFilter("0-1");
        setOpenAlertModal(true);
    }

    const [sendingSms, setSendingSms] = useState(false);

    const sendExpiryAlert = async (selectedDistributorId, timeFilter) => {
        try {
            setSendingSms(true);
            const res = await axios.get(`${Config.send_expiry_alert}?userId=${selectedDistributorId}&timeFilter=${timeFilter}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            });

            if (res?.status === 200) {

                setOpenAlertModal(false);

            }
        } catch (error) {
            console.log(error);
        } finally {
            setSendingSms(false);
        }
    }

    // Search handler
    const searchHandler = (e) => {
        setSearch(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    // Status filter handler
    const statusHandler = (newStatus) => {
        if (status === newStatus) {
            setStatus("");
        } else {
            setStatus(newStatus);
        }
        setCurrentPage(1); // Reset to first page when changing status filter
    };

    // Date filter handlers
    const applyDateFilter = () => {
        setStartDate(tempStartDate);
        setEndDate(tempEndDate);
        setIsFilterActive(!!tempStartDate && !!tempEndDate);
        setCurrentPage(1);
        onClose();
    };


    const resetDateFilter = () => {
        setTempStartDate("");
        setTempEndDate("");
        setStartDate("");
        setEndDate("");
        setIsFilterActive(false);
        setCurrentPage(1);
        onClose();
    };


    // Handle pagination
    // const handlePageChange = (newPage) => {
    //     setCurrentPage(newPage);
    // };

    // // Handle items per page change
    // const handleItemsPerPageChange = (e) => {
    //     setItemsPerPage(Number(e.target.value));
    //     setCurrentPage(1); // Reset to first page when changing items per page
    // };

    const handleRoleDetails = (e) => {

        nav("/RolePage");
    }

    // View distributor details
    const distributorDetails = (id) => {
        const distributor = distributors.find(item => item.id === id);
        if (distributor) {
            // Convert to the format expected by the modal
            const formattedDistributor = {
                CompanyName: distributor.companyName,
                Email: distributor.Email,
                Phone: distributor.Phone,
                PartyCode: distributor.distributorCode,
                Location: distributor.Address,
                UpdatedAt: distributor.UpdatedAt,
                CreatedAt: distributor.CreatedAt,
                Status: distributor.Status ? "Active" : "Inactive",
                // Add any additional fields needed
                ContactPerson: "Contact Person",
                ContactPhone: "+1234567890",
                Address: distributor.Address || "123 Main Street, City, Country",
                Description: "Brief description about the distributor."
            };

            setSelectedDistributor(formattedDistributor);
            onDetailsOpen();
        }
    };

    // Navigate to details page
    function handleNav(id, companyName) {
        // nav(`/distributors/DistributorCNFdetails/${id}`);
        nav(`/distributors/business-details/${id}`, {
            state: {
                disName: companyName
            }
        });
    }

    function handleAssign(id) {
        nav(`/distributors/RolePage/${id}`);
    }

    // Format date for display
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return dateString; // Already in readable format
    };

    const [totalRespItem, setTotalRespItems] = useState(25);
    // const [totalDistributors,settotalDistributors]=useState('10') 

    // const containerRef = useRef(null);
    // const currentPageRef=useRef(1);
    // const [page, setPage] = useState(1);
    // const [pageLimit, setPageLimit] = useState(10);
    // const [isLoadingMore, setIsLoadingMore] = useState(false);
    // const [hasMore, setHasMore] = useState(true);

    // Fetch data

    // Fetch distributor list
const fetchDistributor = async (pageNumber = 1, resetList = false) => {
    // Prevent duplicate requests while loading the next page.
    if (!resetList && isFetchingRef.current) return;

    isFetchingRef.current = true;

    if (!resetList) {
        isFetchingRef.current = true;
        setIsLoadingMore(true);
    } else {
        setLoading(true);
    }

    const requestId = resetList
        ? ++requestIdRef.current
        : requestIdRef.current;

    try {
        const response = await axios.get(
            `${Config.Distributorlist_url}?page=${pageNumber}&limit=${itemsPerPage}&status=${status}&companyName=${encodeURIComponent(search)}&startDate=${startDate}&endDate=${endDate}&isloggedIn=${isLoggedIn}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            }
        );

        // Ignore responses belonging to older filters/searches.
        if (requestId !== requestIdRef.current) return;

        if (response.status === 200) {
            const data = response?.data?.data;
            const newData = data?.distributors || [];

            // Append the next page; replace the list on page 1.
            setDistributors((prev) =>
                resetList ? newData : [...prev, ...newData]
            );

            setTotalItems(data?.totalDistributors ?? 0);
            setTotalRespItems(data?.totalDistributors ?? 0);
            setTotalPages(data?.totalPages ?? 1);

            setCurrentPage(pageNumber);
            currentPageRef.current = pageNumber;

            // Stop when the last page has been reached.
            setHasMore(
                data?.totalPages != null
                    ? pageNumber < data.totalPages
                    : newData.length === itemsPerPage
            );
        }
    } catch (err) {
        console.log(err, "error fetching distributors");
    } finally {
        if (requestId === requestIdRef.current) {
            setLoading(false);
            setIsLoadingMore(false);
            isFetchingRef.current = false;
        }
    }
};

// Fetch page 1 whenever search or filters change.
useEffect(() => {
    setDistributors([]);
    setCurrentPage(1);
    currentPageRef.current = 0;
    setHasMore(true);
    setIsLoadingMore(false);
    isFetchingRef.current = false;

    if (containerRef.current) {
        containerRef.current.scrollTop = 0;
    }

    fetchDistributor(1, true);
}, [
    itemsPerPage,
    status,
    search,
    isFilterActive,
    startDate,
    endDate,
    isLoggedIn,
]);

// Handle infinite scroll
const handleScroll = () => {
    const scrollArea = containerRef.current;

    if (!scrollArea || isFetchingRef.current || !hasMore) return;

    const { scrollTop, clientHeight, scrollHeight } = scrollArea;

    if (scrollTop + clientHeight >= scrollHeight - 20) {
        const nextPage = currentPageRef.current + 1;

        if (nextPage <= totalPages) {
            fetchDistributor(nextPage);
        }
    }
};

// Debounce scroll events
const debounce = (fn, delay) => {
    let timer;

    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
};
    // useEffect(() => {
    //     const fetchData = async () => {
    //         setLoading(true);
    //         try {
    //             const response = await axios.get(
    //                 `${Config.Distributorlist_url}?page=${currentPage}&limit=${itemsPerPage}&status=${status}&companyName=${search}&startDate=${startDate}&endDate=${endDate}&isloggedIn=${isLoggedIn}`,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem('authToken')}`
    //                     }
    //                 }
    //             );
    //             console.log("dfgfdfgfdfgfgfgfgfghghghghghg", response.data);

    //             if (response.status === 200) {
    //                 const data = response?.data?.data;
    //                 setDistributors(data?.distributors);
    //                 setTotalItems(data?.data?.totalDistributors);
    //                 setTotalRespItems(response?.data?.data?.totalDistributors)
    //                 setTotalPages(data?.totalPages || Math.ceil((data.currentPage || data.distributors.length) / currentPage));
    //                 console.log(data.distributors, 'DistributorData');
    //             }
    //         } catch (err) {
    //             console.log(err, 'error fetching distributors');
    //         } finally {
    //             setLoading(false);
    //             // setIsLoadingMore(false);
    //         }
    //     };
    //     fetchData();
    // }, [currentPage, itemsPerPage, status, search, isFilterActive, startDate, endDate, isLoggedIn]);


    //  Checkbox state
    const [selectedRows, setSelectedRows] = useState([]);

    // //  Row select
    const handleCheckboxChange = (id) => {
        setSelectedRows((prev) =>
            prev.includes(id)
                ? prev.filter((rowId) => rowId !== id)
                : [...prev, id]
        );
    };

    //  Select All
    const handleSelectAll = (checked) => {
        if (checked) {
            setSelectedRows(distributors.map((item) => item.distributorCode));
        } else {
            setSelectedRows([]);
        }
    };

    const handleDownload = async () => {
        try {
            const response = await fetch(`${Config.Distributorlist_url}/download`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`
                },
            });

            if (!response.ok) {
                throw new Error("Failed to download file");
            }

            // Response ko Blob (binary data) me convert karna
            const blob = await response.blob();

            // File URL banana
            const url = window.URL.createObjectURL(blob);

            // Anchor tag bana ke programmatically click karna
            const link = document.createElement("a");
            link.href = url;
            link.download = "distributor.csv";
            document.body.appendChild(link);
            link.click();

            // Cleanup
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    //isLoggedIn Filter
    const handleSwitch = () => {
        // fetch(`${Config.Distributorlist_url}`, {
        //     method: "POST",
        //     headers: { 
        //         Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        //         body: JSON.stringify({isLoggedIn: true})
        //     }
        // })
        let a = isLoggedIn ? false : true
        setIsLoggedIn(a);
    }

    return (
        <Box p={4} px={1} pt={1.5} bg="white" borderRadius="15px" boxShadow="sm" overflow={"hidden"}>
            <HStack justify="space-between" alignItems="center" mb="5px">
                <Text fontSize="14px">Distributor / CNF </Text>
                <HStack alignSelf={"end"}>
                    <Flex gap="10px" alignItems="center">
                        <Flex align="center" border="1px solid #ccc" borderRadius="10px" p="5px" height="32px">
                            <Image src={searchIcon} width="16px" />
                            <Input
                                value={search}
                                onChange={searchHandler}
                                placeholder="Search"
                                border="none"
                                ml="5px"
                                fontSize="14px"
                                height="22px"
                            />
                        </Flex>
                        <Button
                            onClick={() => statusHandler("Active")}
                            size="sm"
                            color="white"
                            h={"30px"}
                            bg={status === "Active" ? "#1D9C2A" : "#2EB33B"}
                            borderRadius="15px"
                            boxShadow={status === "Active" ? "0 0 0 2px #1D9C2A inset" : "none"}
                        >
                            Active
                        </Button>
                        <Button
                            onClick={() => statusHandler("Inactive")}
                            size="sm"
                            color="white"
                            h={"30px"}
                            bg={status === "Inactive" ? "#B84F4F" : "#CC5F5F"}
                            borderRadius="15px"
                            boxShadow={status === "Inactive" ? "0 0 0 2px #B84F4F inset" : "none"}
                        >
                            Blocked
                        </Button>
                        <Flex align={"center"}>
                            <Text
                                fontSize={"14px"}
                                // color={"white"} 
                                // bg={"gray.600"} 
                                borderRadius={"10px"}
                                padding={"5px"}
                                fontWeight={"bold"}
                            >
                                Logged in at least once
                            </Text>
                            <Switch
                                size={"md"}
                                marginRight={"15px"}
                                isChecked={isLoggedIn}
                                onChange={handleSwitch}
                            />
                        </Flex>
                    </Flex>

                    <Button
                        size="sm"
                        fontWeight={"400"}
                        border={"1px solid #53545C"}
                        fontSize={"11px"}
                        alignSelf={"end"}
                        onClick={onOpen}
                        height={"30px"}
                        bg={isFilterActive ? "#E9F2FF" : "white"}
                        color={isFilterActive ? "#3182CE" : "inherit"}
                        borderColor={isFilterActive ? "#3182CE" : "#53545C"}
                    >
                        <img src={filterIcon} alt="filter" style={{ marginRight: "5px" }} />
                        {isFilterActive ? "Filtered" : "Filter"}
                    </Button>

                    <Button
                        size="sm"
                        fontWeight="400"
                        border="1px solid #53545C"
                        fontSize="11px"
                        bg="white"
                        height={"30px"}
                        gap={'1'}
                        onClick={handleDownload}
                    ><TbDownload />
                        Download
                    </Button>
                </HStack>
            </HStack>

            {/* Date Filter Modal */}
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Date Filter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <FormControl>
                            <FormLabel>Start Date</FormLabel>
                            <Input
                                type="date"
                                value={tempStartDate}
                                onChange={(e) => setTempStartDate(e.target.value)}
                                max={tempEndDate || undefined}
                            />

                        </FormControl>

                        <FormControl mt={4}>
                            <FormLabel>End Date</FormLabel>
                            <Input
                                type="date"
                                value={tempEndDate}
                                onChange={(e) => setTempEndDate(e.target.value)}
                                min={tempStartDate || undefined}
                            />
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button onClick={applyDateFilter} variant={'outline'} mr={'10px'}>
                            Apply
                        </Button>
                        <Button onClick={resetDateFilter} variant="outline">Reset</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Distributor Details Modal */}
            <Modal isOpen={isDetailsOpen} onClose={onDetailsClose} size="lg">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Distributor /CNF details</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        {loading ? (
                            <Text>Loading details...</Text>
                        ) : selectedDistributor ? (
                            <Box>
                                <HStack justifyContent="space-between" mb={4}>
                                    <Text fontSize="xl" fontWeight="bold">{selectedDistributor.CompanyName}</Text>
                                    <Badge
                                        px={3}
                                        py={1}
                                        borderRadius="8px"
                                        colorScheme={selectedDistributor.Status === "Active" ? "#cc5f5f" : "red"}
                                    >
                                        {selectedDistributor.Status}
                                    </Badge>
                                </HStack>

                                <Divider mb={4} />

                                <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Email</Text>
                                        <Text>{selectedDistributor.Email}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Phone</Text>
                                        <Text>{selectedDistributor.Phone}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Party Code</Text>
                                        <Text>{selectedDistributor.PartyCode}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Location</Text>
                                        <Text>{selectedDistributor.Location}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">User Since</Text>
                                        <Text>{formatDate(selectedDistributor.CreatedAt)}</Text>
                                    </GridItem>
                                    <GridItem>
                                        <Text fontSize="sm" color="gray.500">Last Active</Text>
                                        <Text>{formatDate(selectedDistributor.UpdatedAt)}</Text>
                                    </GridItem>
                                </Grid>

                                {selectedDistributor.Address && (
                                    <Box mt={4}>
                                        <Text fontSize="sm" color="gray.500">Address</Text>
                                        <Text>{selectedDistributor.Address}</Text>
                                    </Box>
                                )}

                                {selectedDistributor.Description && (
                                    <Box mt={4}>
                                        <Text fontSize="sm" color="gray.500">Description</Text>
                                        <Text>{selectedDistributor.Description}</Text>
                                    </Box>
                                )}

                                <Divider my={4} />

                                <Box>
                                    <Text fontSize="sm" mb={2}>Contact Person</Text>
                                    <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                                        <GridItem>
                                            <Text fontSize="sm" color="gray.500">Name</Text>
                                            <Text>{selectedDistributor.ContactPerson || "N/A"}</Text>
                                        </GridItem>
                                        <GridItem>
                                            <Text fontSize="sm" color="gray.500">Phone</Text>
                                            <Text>{selectedDistributor.ContactPhone || "N/A"}</Text>
                                        </GridItem>
                                    </Grid>
                                </Box>
                            </Box>
                        ) : (
                            <Text>No details available</Text>
                        )}
                    </ModalBody>

                    <ModalFooter>
                        <Button onClick={onDetailsClose}>Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal
                isOpen={openAlertModal}
                onClose={() => setOpenAlertModal(false)}
                isCentered
            >
                <ModalOverlay />

                <ModalContent borderRadius="16px">

                    <ModalHeader
                        fontSize="18px"
                        fontWeight="600"
                    >
                        Create Expiry Alert
                    </ModalHeader>

                    <ModalCloseButton />

                    <ModalBody pb={6}>

                        <Text
                            fontSize="14px"
                            color="#4A4A4A"
                            mb={4}
                        >
                            Are you sure you want to create an
                            expiry alert for this distributor?
                        </Text>

                        <FormControl mt={5}>

                            <FormLabel fontSize="14px">
                                Select Expiry Duration
                            </FormLabel>

                            <Select
                                value={timeFilter}
                                onChange={(e) =>
                                    setTimeFilter(e.target.value)
                                }
                            >
                                {FILTER_OPTIONS.map((option) => (
                                    <option
                                        key={option.value}
                                        value={option.value}
                                    >
                                        {option.label}
                                    </option>
                                ))}
                            </Select>

                        </FormControl>

                    </ModalBody>

                    <ModalFooter>

                        <Button
                            variant="outline"
                            mr={3}
                            onClick={() => setOpenAlertModal(false)}
                        >
                            Cancel
                        </Button>

                        <Button
                            colorScheme="blue"
                            isLoading={sendingSms}
                            loadingText="Saving"
                            onClick={() => sendExpiryAlert(selectedDistributorId, timeFilter)}
                        >
                            Save
                        </Button>

                    </ModalFooter>

                </ModalContent>
            </Modal>

            {/* Table */}
            <Box 
                overflowX={"auto"} 
                ref={containerRef} 
                sx={thinScrollbarStyles}
                onScroll={debounce(handleScroll, 100)} 
                w={"100%"} 
                h="calc(100vh - 300px)"
                minH="250px"
                maxH="calc(100vh - 220px)"
                borderTop={"1px solid #ecececff"} 
                borderX={"1px solid #ecececff"} 
                borderBottom={"1px solid #ecececff"} 
                overflowY={'auto'}
            >
                <Table variant="simple" w={"full"} sx={{borderCollapse: "seperate", borderSpacing: 0, tableLayout: "fixed"}} size={"sm"} borderX={"1px solid #ecececff"} borderBottom={"1px solid #ecececff"}  h={"auto"} overflowY={'auto'} overflowX={'auto'}>
                    <colgroup>
                        <col style={{ width: "32px" }} />   {/* Checkbox */}
                        <col style={{ width: "185px" }} />  {/* Distributor / CNF */}
                        <col style={{ width: "115px" }} />  {/* User Since */}
                        <col style={{ width: "135px" }} />  {/* Valid Until */}
                        <col style={{ width: "155px" }} />  {/* Last Active */}
                        <col style={{ width: "110px" }} />  {/* Phone */}
                        <col style={{ width: "245px" }} />  {/* Email */}
                        <col style={{ width: "105px" }} />  {/* Party Code */}
                        <col style={{ width: "145px" }} />  {/* Action */}
                        <col style={{ width: "280px" }} />  {/* Location */}
                        <col style={{ width: "105px" }} />  {/* Status */}
                        <col style={{ width: "145px" }} />  {/* Role Details */}
                        <col style={{ width: "140px" }} />  {/* Profile */}
                    </colgroup>
                    <Thead position={"sticky"} top={0} zIndex={2} bg={"rgb(250, 250, 250)"}>
                        <Tr bg={"rgb(250, 250, 250)"} height={"36px"}>
                            <Th minW={"32px"} maxW={"32px"}><Checkbox
                                isChecked={selectedRows.length === distributors.length && distributors.length > 0}
                                isIndeterminate={
                                    selectedRows.length > 0 && selectedRows.length < distributors.length
                                }
                                onChange={(e) => handleSelectAll(e.target.checked)}
                            /></Th>
                            {tableHeadings.map((item, index) => (
                                <Th key={index} textTransform="none" fontWeight="500" color="black" py={"8px"} fontSize="13px" whiteSpace={"nowrap"}overflow={"hidden"}>
                                    <Flex justify={"space-between"} gap={"4px"} w={"100%"} align="center" minW={0}>
                                        <Text
                                            fontSize="13px"
                                            fontWeight="500"
                                            whiteSpace="nowrap"
                                            flexShrink={0}
                                        >
                                            {item}
                                        </Text>
                                        <Image src={sortIcon} alt="sort" width="14px" height={"14px"} minW={"14px"} flexShrink={0} ml="2" />
                                    </Flex>
                                </Th>
                            ))}
                        </Tr>
                    </Thead>
                    <Tbody overflowY={'auto'}>
                        {loading ? (
                            <Tr>
                                <Td colSpan={tableHeadings.length + 1} textAlign="center" py={4}>
                                    Loading...
                                </Td>
                            </Tr>
                        ) : distributors && distributors.length > 0 ? (
                            distributors.map((item) => (
                                <Tr minH={'36px !important'}
                                    maxH={'36px !important'} key={item.id}fontSize={"12px"}  sx={{
                                        "& td": {
                                            borderBottom: "1px solid #edf0f5",
                                            py: "4px",
                                            fontWeight: "400"
                                        },
                                    }}
                                >
                                    <Td><Checkbox
                                        isChecked={selectedRows.includes(item.distributorCode)}
                                        onChange={() => handleCheckboxChange(item.distributorCode)}
                                    /></Td>
                                    <Td px="12px" overflow="hidden" minW={0}>
                                        <Tooltip label={item.CompanyName || "-"} placement="top" hasArrow>
                                            <Text
                                                fontSize="12px"
                                                color="#6E7079"
                                                whiteSpace="nowrap"
                                                overflow="hidden"
                                                textOverflow="ellipsis"
                                                cursor="pointer"
                                                onClick={() =>
                                                    handleNav(item.DistributorID, item.CompanyName)
                                                }
                                            >
                                                {item.CompanyName || "-"}
                                            </Text>
                                        </Tooltip>
                                    </Td>
                                    {/* <Td color="#6E7079">{item["type"]}</Td> */}
                                    <Td fontSize="12px" color="#6E7079" whiteSpace="nowrap" overflow="hidden">
                                        <Text whiteSpace="nowrap">
                                            {formatDateOnly(item.CreatedAt)}
                                        </Text>
                                    </Td>
                                    <Td fontSize="12px" color="#6E7079" whiteSpace="nowrap" overflow="hidden">
                                        <Text whiteSpace="nowrap">
                                            {formatDateOnly(item.expiryDate)}
                                        </Text>
                                    </Td>
                                    <Td fontSize="12px" color="#6E7079" whiteSpace="nowrap" overflow="hidden">
                                        <Text whiteSpace="nowrap">
                                            {formatLastActive(item.UpdatedAt)}
                                        </Text>
                                    </Td>
                                    <Td fontSize={"12px"} color="#6E7079" overflow={"hidden"}>
                                        <Text whiteSpace="nowrap">{item["Phone"]}</Text>
                                    </Td>
                                    <Td
                                        fontSize="12px"
                                        overflow="hidden"
                                        minW={0}
                                        maxW="285px"
                                    >
                                        <Flex
                                            align="center"
                                            gap={2}
                                            minW={0}
                                            width="100%"
                                            overflow="hidden"
                                        >
                                            <Tooltip
                                                label={item.Email || "-"}
                                                placement="top"
                                                hasArrow
                                            >
                                                <Text
                                                    color="#6E7079"
                                                    flex="1"
                                                    minW={0}
                                                    whiteSpace="nowrap"
                                                    overflow="hidden"
                                                    textOverflow="ellipsis"
                                                >
                                                    {item.Email || "-"}
                                                </Text>
                                            </Tooltip>

                                            <IconButton
                                                icon={<Image src={copyIcon} width="12px" />}
                                                size="xs"
                                                flexShrink={0}
                                                ml={0}
                                                variant="ghost"
                                                onClick={() =>
                                                    navigator.clipboard.writeText(item.Email || "")
                                                }
                                                aria-label="Copy email"
                                            />
                                        </Flex>
                                    </Td>
                                    <Td fontSize={"12px"} paddingLeft={"1rem"} paddingRight={"1rem"} color="#6E7079">{item["distributorCode"]}</Td>
                                    <Td fontSize={"12px"} color={"#6E7079"}>
                                        <Button fontSize={"12px"} height={"30px"} onClick={() => handleOpenAlertModal(item?.DistributorID)}>Expiry Alert</Button>
                                    </Td>
                                    <Td
                                        fontSize="12px"
                                        color="#6E7079"
                                        overflow="hidden"
                                        minW={0}
                                    >
                                        <Tooltip
                                            label={item.Address || "-"}
                                            placement="top"
                                            hasArrow
                                        >
                                            <Text
                                                noOfLines={2}
                                                lineHeight="18px"
                                                maxH="36px"
                                                overflow="hidden"
                                                wordBreak="break-word"
                                            >
                                                {item.Address || "-"}
                                            </Text>
                                        </Tooltip>
                                    </Td>
                                    {/* <Td color="#6E7079">
                                        {`${new Date(item["UpdatedAt"]).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })} -  ${new Date(item["UpdatedAt"]).toLocaleTimeString('en-IN')}`}
                                    </Td> */}
                                    {/* <Td color="#6E7079">{new Date(item["CreatedAt"]).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })}</Td> */}
                                    <Td fontSize={"12px"}>
                                        <Button
                                            size="xs"
                                            backgroundColor={
                                                item.Status === 'Active'
                                                    ? '#32936f2b'
                                                    : item.Status === 'Inactive'
                                                        ? '#cc5f5f4f'
                                                        : ''
                                            }
                                            color={
                                                item.Status === 'Active'
                                                    ? '#519C66'
                                                    : item.Status === 'Inactive'
                                                        ? '#cc5f5f'
                                                        : ''
                                            }
                                            borderRadius="8px"
                                        >
                                            {item.Status === 'Active'
                                                ? 'Active'
                                                : item.Status === 'Inactive'
                                                    ? 'Blocked'
                                                    : ''}
                                        </Button>
                                    </Td>
                                    {/* <Td>
                                        <IconButton
                                            onClick={() => handleNav(item.DistributorID)}
                                            icon={<Image src={eyeIcon} width="18px" />}
                                            variant="ghost"
                                            size="sm"
                                        />
                                    </Td> */}
                                    <Td fontSize={"12px"}>
                                        <Button fontSize={"12px"} height={"30px"} onClick={() => handleAssign(item.DistributorID)}>
                                            Assign Role
                                        </Button>
                                    </Td>
                                    <Td fontSize={"12px"}>
                                        <Button fontSize={"12px"} h={"30px"} onClick={() => nav(`/distributors/DistributorCNFdetails/${item.DistributorID}`)}>
                                            View Profile
                                        </Button>
                                    </Td>
                                </Tr>
                            ))
                        ) : (
                            <Tr>
                                <Td colSpan={tableHeadings.length + 1} textAlign="center" py={4}>
                                    No data available
                                </Td>
                            </Tr>
                        )}
                        {isLoadingMore && !loading && (
                            <Tr>
                                <Td
                                    colSpan={tableHeadings.length + 1}
                                    textAlign="center"
                                    py={4}
                                >
                                    Loading more distributors...
                                </Td>
                            </Tr>
                        )}
                    </Tbody>
                </Table>
            </Box>

            {/* Pagination */}
            {/* <Box>
                {!loading && distributors && distributors.length > 0 && (
                    <Flex justify="space-between" align="center" mt={4}>
                        <Flex align="center">
                            <Select
                                size="sm"
                                w="70px"
                                height="23px"
                                borderRadius="8px"
                                backgroundColor="#f0f4f9"
                                mr={2}
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>

                            </Select>
                            <Text fontSize="sm" color="#666666">Items per page</Text>
                            <Text fontSize="14px" color="#666666" marginLeft="12px">
                                {Math.min(1 + (currentPage - 1) * itemsPerPage, totalRespItem)}-
                                {Math.min(currentPage * itemsPerPage, totalRespItem)} of {totalRespItem} items
                            </Text>
                        </Flex>

                        <Flex align="center">
                            <Select
                                size="sm"
                                w="60px"
                                height="23px"
                                borderRadius="8px"
                                backgroundColor="#f0f4f9"
                                mr={1}
                                value={currentPage}
                                onChange={(e) => handlePageChange(Number(e.target.value))}
                            >
                                {[...Array(totalPages).keys()].map(page => (
                                    <option key={page + 1} value={page + 1}>{page + 1}</option>
                                ))}
                            </Select>
                            <Text fontSize="14px" color="#666666" marginLeft="8px">of {totalPages} pages</Text>
                            <IconButton
                                icon={<FiChevronLeft />}
                                variant="ghost"
                                size="sm"
                                aria-label="Previous page"
                                mr={1}
                                onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                                isDisabled={currentPage === 1}
                            />

                            <IconButton
                                icon={<FiChevronRight />}
                                variant="ghost"
                                size="sm"
                                aria-label="Next page"
                                onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                                isDisabled={currentPage === totalPages}
                            />
                        </Flex>
                    </Flex>
                )}
            </Box> */}
        </Box>
    );
};

export default Distributorlist;